import InvestInvestments from './InvestInvestments';

export default InvestInvestments;
